import {useTranslation} from "react-i18next";
import {
    TerminationCommunication,
    TerminationCommunicationField,
    TerminationMailType,
} from "../../../app/api/model/termination";
import {ColumnDef, FilterDef, FilterOperator, FilterType, IdModelTable} from "../../../components/ExTable";
import {formatTimestamp} from "../../../utils/datetime";
import {TranslationContext, getTranslation} from "../../../utils/getTranslationKey";
import {getMailCellContent} from "../helpers";
import {useTerminationCommunicationListQuery} from "../../../app/api/api";

export interface TerminationCommunicationTabProps {
    terminationId: number;
}

export function TerminationCommunicationTab({terminationId}: Readonly<TerminationCommunicationTabProps>) {
    const {t} = useTranslation();
    const columnDefs: ColumnDef<TerminationCommunication>[] = [
        {
            fieldName: TerminationCommunicationField.SENT_AT,
            align: "left",
            label: t("generic_sentAt"),
            width: 200,
            sortable: true,
            formatCellText: ({cellValue}) => {
                return formatTimestamp(cellValue);
            },
            sticky: true,
        },
        {
            fieldName: TerminationCommunicationField.MAIL_TYPE,
            align: "left",
            label: t("generic_mailType"),
            width: 100,
            sortable: true,
            formatCellText: ({row}) =>
                getMailCellContent({
                    mailType: row[TerminationCommunicationField.MAIL_TYPE],
                    t,
                }) ?? "",
        },
    ];
    const filterDefs: FilterDef<TerminationCommunication>[] = [
        {
            fieldName: TerminationCommunicationField.SENT_AT,
            filterOperators: [FilterOperator.LT, FilterOperator.GT, FilterOperator.LTE, FilterOperator.GTE],
            type: FilterType.DATE_TIME,
        },
        {
            fieldName: TerminationCommunicationField.MAIL_TYPE,
            filterOperators: [FilterOperator.EQ, FilterOperator.NOT],
            enumValues: Object.values(TerminationMailType).map((mailType) => ({
                value: mailType,
                labelKey: getTranslation({context: TranslationContext.TERMINATION_MAIL_TYPE, value: mailType, t}),
            })),
            type: FilterType.ENUM,
        },
    ];
    return (
        <IdModelTable
            queryHook={useTerminationCommunicationListQuery}
            additionalRequestParams={{id: terminationId, params: {sort: "-sentAt"}}}
            columnDefs={columnDefs}
            filterDefs={filterDefs}
            title={t("termination_communications")}
        />
    );
}
